<div class="container-wrapper" *ngIf="!isLoadingChannel && systemColors">
    <div class="container">
        <div *ngIf="selectedElement">
            <div class="add-to-library" *ngIf="showAddLibrary() && userCanEdit">
                <div class="open-add-library-container">
                    <div
                        class="select-button justify-end"
                        data-cy="mimics-add-to-library-button"
                        (click)="openLibraryContainer()"
                        *ngIf="!isOpenAddLibraryContainer">
                        {{ 'editor.library.settings.add-library' | translate }}
                    </div>
                </div>
                <app-create-library-component-container
                    [isOpenAddLibraryContainer]="isOpenAddLibraryContainer"
                    [libraryList]="libraryList"
                    [elementSettings]="elementSettings"
                    [element]="selectedElement"
                    [shipyardId]="shipyardId"
                    [vessel]="vessel"
                    (onClearCreateComponent)="clearLibraryContainer()">
                </app-create-library-component-container>
            </div>
            <app-pump-object-setting
                *ngIf="isPumpElement"
                [selectedElement]="selectedElement"
                [userCanEdit]="userCanEdit">
            </app-pump-object-setting>
            <div class="edit-condition" *ngIf="!elementIntegration">
                <div class="integration-container">
                    <h6 class="integration-title">
                        {{ 'settings-side-menu.integration.title' | translate }}
                    </h6>
                    <span class="integration-description">
                        {{ 'settings-side-menu.integration.description' | translate }}
                    </span>
                    <app-button
                        text="settings-side-menu.integartion.button-text"
                        [disable]="!userCanEdit"
                        customFontSize="14px"
                        customFontFamily="NotoSans-SemiBold"
                        size="small"
                        (onClick)="openIntegrationDialog()">
                    </app-button>
                </div>
            </div>
        </div>
        <div class="integration-infomation-container" *ngIf="elementIntegration && !isMotorElement">
            <div class="integration-state">
                <span class="integration-type">{{
                    (elementIntegration.type === STATUS_COLOR
                        ? 'integration.settings.status-color.text'
                        : 'integration.settings.visual-state.text'
                    ) | translate
                }}</span>
                <mat-icon class="icon" svgIcon="close" (click)="deleteIntegration()"></mat-icon>
            </div>
            <div
                class="select-button none-padding"
                (click)="
                    elementIntegration.type === STATUS_COLOR
                        ? clearElementSetting()
                        : openIntegrationDialog(elementIntegration)
                ">
                {{
                    (elementIntegration.type === STATUS_COLOR
                        ? 'integration.settings.status-color.button-text'
                        : 'integration.settings.visual-state.button-text'
                    ) | translate
                }}
            </div>
        </div>
        <div class="trigger-condition" *ngIf="elementIntegration?.type === VISUAL_STATE">
            <div class="trigger-condition-header">
                <div class="trigger-condition-title">
                    {{ 'integration.settings.trigger-conditions.title' | translate }}
                </div>
                <mat-icon
                    class="icon plus-icon"
                    [class.opening]="isOpeningTriggerConditionDialog"
                    [class.disabled]="elementIntegration.elementCondition"
                    svgIcon="plus"
                    (click)="openTriggerConditionDialog($event)"></mat-icon>
            </div>
            <div class="select-button none-padding" (click)="openMatrixDialog()">
                {{ 'integration.settings.trigger-conditions.button-text' | translate }}
            </div>
            <div class="integration-condition-container" *ngIf="elementIntegration.elementCondition">
                <div class="integration-condition" (click)="showComponentShape()" [class.active]="prevElement">
                    {{ elementIntegration?.elementCondition.name }}
                </div>
                <div class="icon-container">
                    <mat-icon
                        class="icon minus-icon information-icon"
                        [class.opening]="isOpeningTriggerConditionLogicDialog"
                        svgIcon="info"
                        (click)="openTriggerConditionLogicDialog($event)"></mat-icon>
                    <mat-icon class="icon minus-icon" svgIcon="minus" (click)="deleteIntegrationCondition()"></mat-icon>
                </div>
            </div>
        </div>
        <ng-container *ngIf="elementIntegration?.type === STATUS_COLOR && isValveElement">
            <div class="options-container">
                <app-valve-object-setting
                    #valveObjectSetting
                    [selectedElement]="selectedElement"
                    [vessel]="vessel"
                    [mimicId]="mimicId"
                    [userCanEdit]="userCanEdit"
                    [elementSettings]="elementSettings"
                    [elementIntegration]="elementIntegration"
                    [systemColors]="systemColors">
                </app-valve-object-setting>
            </div>
        </ng-container>

        <ng-container *ngIf="elementIntegration?.type === STATUS_COLOR && isMotorElement">
            <div class="options-container">
                <app-motor-object-setting
                    #motorObjectSetting
                    [selectedElement]="selectedElement"
                    [vessel]="vessel"
                    [mimicId]="mimicId"
                    [userCanEdit]="userCanEdit"
                    [elementSettings]="elementSettings"
                    [elementIntegration]="elementIntegration"
                    [systemColors]="systemColors">
                </app-motor-object-setting>
            </div>
        </ng-container>

        <ng-container *ngIf="elementIntegration?.type === STATUS_COLOR && isDefaultElement">
            <div class="options-container">
                <app-default-element-settings
                    #defaultElemSetting
                    [selectedElement]="selectedElement"
                    [vessel]="vessel"
                    [mimicId]="mimicId"
                    [userCanEdit]="userCanEdit"
                    [elementSettings]="elementSettings"
                    [elementIntegration]="elementIntegration">
                </app-default-element-settings>
            </div>
        </ng-container>

        <ng-container *ngIf="elementIntegration?.type === STATUS_COLOR && isControlObject">
            <div class="options-container">
                <app-control-element-settings
                    #controlElemSetting
                    [selectedElement]="selectedElement"
                    [vessel]="vessel"
                    [mimicId]="mimicId"
                    [userCanEdit]="userCanEdit"
                    [elementSettings]="elementSettings"
                    [elementIntegration]="elementIntegration">
                </app-control-element-settings>
            </div>
        </ng-container>
    </div>

    <div *ngIf="userCanEdit && elementIntegration?.type === STATUS_COLOR" class="save-container">
        <div (click)="saveSettings()" [class.disable-save]="!hasChanges()" class="save-button">
            {{ 'mimics.settings.button.save' | translate }}
        </div>
    </div>
</div>

<ng-container *ngIf="isLoadingChannel || !systemColors">
    <app-loading-spinner class="spinner-component"></app-loading-spinner>
</ng-container>

<app-confirmation-window
    #deleteDialog
    mainLabel="integration.dialog.delete.title"
    subLabel="integration.dialog.delete.description"
    [goBackLabel]="'dlg.cancel'"
    [saveLabel]="'dlg.confirm'"
    [inverseColors]="true">
</app-confirmation-window>
